import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackAccessoryInformationClickEventData } from './legacy-types';
import { mapElasticVehicleToLegacyItem } from './utils';

interface UseLegacyTrackAccessoryInformationClickVariables {
  vehicle: ElasticVehicle;
  information: {
    context: 'productOverview';
    id: string;
    label: string;
  };
}

export const createLegacyTrackAccessoryInformationClick = (
  market: Market,
  variables: UseLegacyTrackAccessoryInformationClickVariables,
): LegacyTrackAccessoryInformationClickEventData => {
  const eventData: LegacyTrackAccessoryInformationClickEventData = {
    eventType: 'accessoryInformationClick',
    item: mapElasticVehicleToLegacyItem(market, variables.vehicle),
    pageType: 'product page',
    information: variables.information,
  };

  return eventData;
};

export const useLegacyTrackAccessoryInformationClick = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();

  const trackLegacyAccessoryInformationClick = useCallback(
    (variables: UseLegacyTrackAccessoryInformationClickVariables) => {
      track({
        event: 'accessoryInformationClick',
        data: createLegacyTrackAccessoryInformationClick(market, variables),
      });
    },
    [track],
  );

  return {
    trackLegacyAccessoryInformationClick,
  };
};
